import styled, { css } from 'styled-components';

interface ItemType {
  type?: 'date' | 'hour';
}

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: stretch;
  padding-bottom: 10px;
  gap: 16px;
`;

export const Values = styled.div`
  display: grid;
  grid-template-columns: min-content 1fr;
  gap: 16px;
`;

export const Hours = styled.div`
  display: flex;
  flex-direction: column;

  align-self: center;
  gap: 8px;
  font-weight: 500;
  font-size: 14px;

  span {
    padding: 9px 7px;
  }
`;

export const Dates = styled.div`
  display: flex;
  max-width: 800px;
  overflow-x: auto;
  gap: 24px;
`;

export const Item = styled.div<ItemType>`
  display: flex;
  flex-direction: column;
  align-items: center;

  span {
    font-weight: 500;
    white-space: nowrap;
    color: #1c71a1;
    padding: 9px 7px;
  }

  ${(props) =>
    props.type === 'date' &&
    css`
      & div:last-child {
        border-bottom: 1px solid #8c919c;
      }

      & div:first-of-type {
        border-top: 1px solid #8c919c;
      }

      span {
        color: #707683;
        margin-bottom: 16px;
      }
    `}

  ${(props) =>
    props.type === 'hour' &&
    css`
      & div:nth-child(1) {
        margin-bottom: 16px;
        padding: 0;
        visibility: hidden;
      }

      align-self: flex-end;
    `}

  div {
    text-align: center;
    min-width: 70px;
    padding: 9px 7px;
    border: 0;

    ${(props) =>
      props.type === 'date' &&
      css`
        border: 1px solid #8c919c;
        border-bottom: 0;
        border-top: 0;

        &:nth-child(odd) {
          background-color: #f7f7f8;
        }
      `}

    strong {
      color: #1c71a1;
      font-weight: 700;
    }
  }
`;
